import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6e3028f1")

_pushScopeId("data-v-6e3028f1")
const _hoisted_1 = { class: "slide-animation-panel" }
const _hoisted_2 = { class: "animation-pool" }
const _hoisted_3 = { class: "animation-text" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("应用到全部")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.animations, (item) => {
        return (_openBlock(), _createBlock("div", {
          class: ["animation-item", { 'active': _ctx.currentTurningMode === item.value }],
          key: item.label,
          onClick: ($event: any) => (_ctx.updateTurningMode(item.value))
        }, [
          _createVNode("div", {
            class: ['animation-block', item.value]
          }, null, 2),
          _createVNode("div", _hoisted_3, _toDisplayString(item.label), 1)
        ], 10, ["onClick"]))
      }), 128))
    ]),
    _createVNode(_component_Button, {
      style: {"width":"100%"},
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.applyAllSlide()))
    }, {
      default: _withId(() => [
        _hoisted_4
      ]),
      _: 1
    })
  ]))
})